export const Boolean = {
  YES: true,
  NO: false,
  ACTIVE: true,
  DE_ACTIVE: false,
}